import { createSlice } from "@reduxjs/toolkit";
import toolsInitialState from "@/components/ToolsPage/redux/initialState";
import ToolsReducer from "@/components/ToolsPage/redux/reducers";

const toolsSlice = createSlice({
  name: "tools",
  initialState: toolsInitialState,
  reducers: ToolsReducer,
});

export const { setToolsData, setToolContentData, setToolType } = toolsSlice.actions;

export default toolsSlice.reducer;
